module.exports = __webpack_public_path__ + "media/images/help/line/heading-point-4-548be5ff663e51c74b364bd426058df2.svg";